export const labelOr = (
  t: (key: string) => string,
  key: string,
  fallback: string,
): string => {
  const label = t(key);
  return label === key ? fallback : label;
};
